import { render, staticRenderFns } from "./ent-remote-select.vue?vue&type=template&id=895e8802&"
import script from "./ent-remote-select.vue?vue&type=script&lang=js&"
export * from "./ent-remote-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports